import 'script-js/entrypoint';